import React from 'react';
import { motion } from 'framer-motion';
import { MonitorSmartphone, Code, ShoppingCart, Search, Wrench, LayoutTemplate, Briefcase, RefreshCw } from 'lucide-react';
const services = [{
  icon: <MonitorSmartphone size={32} data-id="element-314" data-mp="1dtsnirve391d" />,
  title: 'Website Design',
  description: 'Stunning, modern designs tailored to your brand identity that captivate visitors instantly.',
  color: 'from-blue-600 to-blue-500'
}, {
  icon: <Code size={32} data-id="element-315" data-mp="13w4rzzpylxi5" />,
  title: 'Website Development',
  description: 'Clean, fast, and responsive built with the latest modern web technologies.',
  color: 'from-blue-600 to-blue-500'
}, {
  icon: <ShoppingCart size={32} data-id="element-316" data-mp="u5a30nlbwjt0" />,
  title: 'E-Commerce Websites',
  description: 'Secure, high-converting online stores designed to maximize your sales and revenue.',
  color: 'from-blue-600 to-blue-500'
}, {
  icon: <Search size={32} data-id="element-317" data-mp="l4bw9xji9y6q" />,
  title: "Lite SEO Optimization",
  description: 'Built-in best practices to help your site rank higher on Google and attract organic traffic.',
  color: 'from-blue-600 to-blue-500'
}, {
  icon: <Wrench size={32} data-id="element-318" data-mp="36awpahu6bz1a" />,
  title: 'Website Maintenance',
  description: 'Support, updates, and security checks to keep your site running smoothly.',
  color: 'from-blue-600 to-blue-500'
}, {
  icon: <RefreshCw size={32} data-id="element-319" data-mp="2xd2x9j3fzrjx" />,
  title: 'Website Redesigns',
  description: 'Breathe new life into your outdated website with a modern, performance-focused overhaul.',
  color: 'from-blue-600 to-blue-500'
}];
export function Services() {
  return <section id="services" className="py-24 bg-black relative border-y border-white/5" data-id="element-320" data-mp="3pym5drsr0auo">
      <div className="container mx-auto px-6 md:px-12" data-id="element-321" data-mp="3tzxyi7atze7m">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-322" data-mp="3g17v69xf4iat">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-white mb-6" data-id="element-323" data-mp="3l13xm4qgw1o9">
            Everything You Need to{' '}
            <span className="text-gradient" data-id="element-324" data-mp="24m2o6tq97xle">Succeed Online</span>
          </h2>
          <p className="text-lg text-[#FFFFFF]" data-id="element-325" data-mp="29mqd99uxa4cz">
            Designed to elevate your brand and drive real business results.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-326" data-mp="1pjay3oiki3yu">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-[#111118] border border-white/5 rounded-2xl p-8 hover:border-blue-500/30 hover:bg-[#161622] transition-all group" data-id="element-327" data-mp="1lkln22l04yid" data-mpi={index}>
              <div className={`w-14 h-14 rounded-xl bg-gradient-to-br ${service.color} flex items-center justify-center text-white mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300`} data-id="element-328" data-mp="xswsefkpjxy9">
                {service.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3 font-heading" data-id="element-329" data-mp="2s5mj6ofs4r1f">
                {service.title}
              </h3>
              <p className="text-sm leading-relaxed text-[#FFFFFF]" data-id="element-330" data-mp="2n5ryj2mlkxot">
                {service.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}